export default class ExamService {
  constructor(baseUri) {
    this.baseUri = baseUri
  }

  async create(exam, options) {
    const response = await fetch(`${this.baseUri}/learning/exam`, {
      body: JSON.stringify(exam),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUri}/learning/exam/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUri}/learning/exam/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUri}/learning/exam`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async getAllForInvitationKey(invitationKey, options) {
    const response = await fetch(`${this.baseUri}/learning/exam/invitation/${invitationKey}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async evaluate(invitationKey, id, examAnswers, options) {
    const response = await fetch(`${this.baseUri}/learning/exam/invitation/${invitationKey}/${id}`, {
      body: JSON.stringify(examAnswers),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return response.ok
  }

  async update(id, exam, options) {
    const response = await fetch(`${this.baseUri}/learning/exam/${id}`, {
      body: JSON.stringify(exam),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }


  async createTrainee(examId, trainee, options) {
    const response = await fetch(`${this.baseUri}/learning/exam/${examId}/trainee`, {
      body: JSON.stringify(trainee),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async deleteTrainee(examId, id, options) {
    const response = await fetch(`${this.baseUri}/learning/exam/${examId}/trainee/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async findTrainee(examId, id, options) {
    try {
      const response = await fetch(`${this.baseUri}/learning/exam/${examId}/trainee/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAllTrainees(examId, options) {
    const response = await fetch(`${this.baseUri}/learning/exam/${examId}/trainee`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async updateTrainee(examId, id, trainee, options) {
    const response = await fetch(`${this.baseUri}/learning/exam/${examId}/trainee/${id}`, {
      body: JSON.stringify(trainee),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }
}